const $ = require('jquery')
window.$ = $
window.jQuery = $
require('../fomantic/src/dist/semantic.js')
import Vue from 'vue'
import store from './store.js'
import App from './App.vue'
import VueGtag from "vue-gtag";
import AsyncComputed from 'vue-async-computed'
import printf from 'printf'
import router from './router'
import Bowser from "bowser";

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_TRACKING_ID }
}, router);
Vue.use(AsyncComputed);

Vue.config.productionTip = false

Vue.mixin({
  data: () => {
    return {
      screen_width: window.innerWidth,
    }
  },
  computed: {
    $() {
      return window.$;
    },
    client() {
      return this.$store.state.client;
    },
    screen_lg() {
      return this.screen_width > 992;
    },
    screen_md() {
      return this.screen_width > 768;
    },
    browser_ok() {
      const browser = Bowser.getParser(window.navigator.userAgent);
      return browser.satisfies({
        chrome: ">37",
        safari: ">=10.1",
        edge: ">=12",
        firefox: ">=34",
      });
    },
    browser() {
      const browser = Bowser.getParser(this.user_agent);
      return browser.getBrowser();
    },
    user_agent() {
      return window.navigator.userAgent;
    },
    has_dir_upload() {
      var ua = this.user_agent.toLowerCase();
      return this.browser_ok && !ua.includes('android') &&
             !ua.includes("iphone");
    },
  },
  methods: {
    reset_data() {
      Object.assign(this.$data, this.$options.data());
    },
    file_icon(e) {
      if (e.type == "dir")
        return "folder";

      const iconMap = new Map([
        ["torrent", ["download"]],
        ["exe", ["window", "restore", "outline"]],
        ["msi", ["window", "restore", "outline"]],
        ["pdf", ["file", "pdf"]],
        ["jpg", ["file", "image", "outline"]],
        ["jpeg", ["file", "image", "outline"]],
        ["png", ["file", "image", "outline"]],
        ["ico", ["file", "image", "outline"]],
        ["gif", ["file", "image", "outline"]],
        ["avi", ["file", "video", "outline"]],
        ["rmvb", ["file", "video", "outline"]],
        ["mkv", ["file", "video", "outline"]],
        ["mp4", ["file", "video", "outline"]],
        ["wmv", ["file", "video", "outline"]],
        ["mov", ["file", "video", "outline"]],
        ["ogg", ["file", "video", "outline"]],
        ["webm", ["file", "video", "outline"]],
        ["zip", ["file", "archive", "outline"]],
        ["rar", ["file", "archive", "outline"]],
        ["7z", ["file", "archive", "outline"]],
        ["tar", ["file", "archive", "outline"]],
        ["ppt", ["file", "powerpoint"]],
        ["pptx", ["file", "powerpoint"]],
        ["xls", ["file", "excel"]],
        ["xlsx", ["file", "excel"]],
        ["md", ["file"]],
        ["txt", ["file"]],
        ["js", ["file", "code"]],
        ["json", ["file", "code"]],
        ["c", ["file", "code"]],
        ["cpp", ["file", "code"]],
        ["html", ["file", "code"]],
        ["java", ["file", "code"]],
        ["vue", ["file", "code"]],
        ["php", ["file", "code"]],
      ]);
      var lower = e.name.toLowerCase();
      var dotindex = lower.lastIndexOf('.');
      if (dotindex > 0) {
        var suff = lower.slice(dotindex + 1);
        var i = iconMap.get(suff);
        if (i) {
          return i;
        }
      }
      return 'file'
    },
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    toast(type, message) {
      $('body').toast({
        class: type,
        closeOnClick: false,
        displayTime: 5000,
        message,
      });
    },
    show_error(message) {
      return this.toast('brown', message);
    },
    show_success(message) {
      return this.toast('teal', message);
    },
    is_string(x) {
      return Object.prototype.toString.call(x) === "[object String]"
    },
    error_text(e) {
      if (!this.is_string(e)) {
        e = e.response ? e.response.data : e.message;
        if (Array.isArray(e)) {
          e = e[0];
        }
      }
      switch (e) {
        case 'EEXIST':
          var x = e.params && e.params.name ? e.params.name : '';
          return '文件' + x + '已存在';
        case 'ENOENT':
          return '找不到文件';
        case 'EINVAL':
          return '无效操作';
        case 'ETOOMANY':
          return '文件数量超出限制';
        case 'ENOSPC':
          return '空间不足';
        case 'EQUOTA':
          return '资源不足';
        default:
          return '未知错误（' + e + '）';
      }
    },
    show_modal(id, nested=false, opts={}) {
      var r = $("#" + id);
      opts.allowMultiple = nested;
      //opts.detachable = nested;
      var x = r.modal(opts);
      if (!nested)
        x.modal("hide all");
      x.modal("show");
    },
    hide_modal(id) {
      $("#" + id).modal("hide");
    },
    show_confirm(opts) {
      this.$store.commit('set_confirm_opts', opts);
      process.nextTick(() => {
        this.show_modal("confirm-modal", true);
      });
    },
    format_time(t) {
      if (!t) {
        return 'N/A';
      }
      return this.format_time_ms(t * 1000);
    },
    format_time_ms(t) {
      if (!t) {
        return 'N/A';
      }
      var e = new Date(t);
      return printf("%d-%02d-%02d %02d:%02d", e.getFullYear(), e.getMonth() + 1,
                    e.getDate(), e.getHours(), e.getMinutes());
    },
    format_date_ms(t) {
      if (!t) {
        return 'N/A';
      }
      var e = new Date(t);
      return printf("%d-%02d-%02d", e.getFullYear(), e.getMonth() + 1,
                    e.getDate());
    },
    format_date(t) {
      return this.format_date_ms(t * 1000);
    },
    bytes_to_human(bytes, no_gb=false, precision=1) {
      var num, unit;
      if (!no_gb && bytes >= (1 << 30)) {
        unit = "GB";
        num = printf("%." + precision + "f", bytes / (1 << 30));
      } else if (bytes >= (1 << 20)) {
        unit = "MB";
        num = printf("%." + precision + "f", bytes / (1 << 20));
      } else if (bytes >= (1 << 10)) {
        unit = "KB";
        num = printf("%." + precision + "f", bytes / (1 << 10));
      } else {
        unit = "B";
        num = printf("%d", bytes);
      }
      if (num.endsWith(".0")) {
        num = num.slice(0, num.indexOf('.'));
      }
      return num + " " + unit;
    }
  },
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
